// Bridges the ESA_SEND_MESSAGE shell event to the ESA Panel converse flow.
// Call once at the EsaPanel root. When any Surface dispatches ESA_SEND_MESSAGE,
// this hook switches the panel to chat mode and invokes sendMessage.
import { useEffect, useRef } from 'react';
import { shellEventBus } from '../../../shell/events/eventBus';
import { useShellStore } from '../../../shell/store/shellStore';
import type { UseEsaConverseReturn } from './useEsaConverse';

export function useEsaBusSendMessage(
  sendMessage: UseEsaConverseReturn['sendMessage']
): void {
  // Hold a stable ref to avoid re-subscribing on every render
  const sendRef = useRef(sendMessage);
  sendRef.current = sendMessage;

  const setEsaPanelMode = useShellStore.getState().setEsaPanelMode;
  const setEsaPanelOpen = useShellStore.getState().setEsaPanelOpen;

  useEffect(() => {
    return shellEventBus.on('ESA_SEND_MESSAGE', e => {
      const { message } = e.payload;
      // Open panel and switch to chat mode
      setEsaPanelOpen(true);
      setEsaPanelMode('chat');
      void sendRef.current(message);
    });
  }, [setEsaPanelMode, setEsaPanelOpen]);
}
